import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState } from 'react';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',

        }}
        {...props}
        sx={{ top: "-5px"}}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

const filters = [
    {
        id: 1,
        text: "Sort A-Z"
    },
    {
        id: 2,
        text: "Sort Z-A"
    },
    // {
    //     id: 3,
    //     text: "Last 15 days"
    // },
    // {
    //     id: 4,
    //     text: "Last 30 days"
    // },
    // {
    //     id: 5,
    //     text: "Last Quarter"
    // },
    // {
    //     id: 6,
    //     text: "Last year"
    // }


]
export default function DropDownMenu(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
   

    const handleChange = (event) => {
        props.setValue(event.target.value);
        props.data(event.target.value)
        handleClose()
    };
    // useEffect(()=>{
    //     props.data(value)
    //     console.log(value);
    // },[value])

    return (
        <div>
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                disableElevation
                disableRipple
                sx={{
                    outline: "none !important", border: "1.5px solid #868686", color: "#868686", textTransform: "none", padding: "5px 18px", display: "flex", gap: "6px", "&:hover": {
                        background: "transparent !important"
                    },
                }}
                onClick={handleClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M6.80065 5.54163H13.1923C13.7257 5.54163 14.159 5.97496 14.159 6.50829V7.57496C14.159 7.96663 13.9173 8.44996 13.6757 8.69163L11.5923 10.5333C11.3007 10.775 11.109 11.2583 11.109 11.65V13.7333C11.109 14.025 10.9173 14.4083 10.6757 14.5583L10.0007 14.9833C9.36732 15.375 8.50065 14.9333 8.50065 14.1583V11.5916C8.50065 11.25 8.30898 10.8166 8.10898 10.575L6.26732 8.63329C6.02565 8.39996 5.83398 7.95829 5.83398 7.66663V6.55829C5.83398 5.97496 6.26732 5.54163 6.80065 5.54163Z" stroke="#868686" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.49935 18.3333H12.4993C16.666 18.3333 18.3327 16.6666 18.3327 12.5V7.49996C18.3327 3.33329 16.666 1.66663 12.4993 1.66663H7.49935C3.33268 1.66663 1.66602 3.33329 1.66602 7.49996V12.5C1.66602 16.6666 3.33268 18.3333 7.49935 18.3333Z" stroke="#868686" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Filter
            </Button>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                
            >
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={props.value}
                        onChange={handleChange}
                        sx={{paddingLeft:"20px"}}
                    >                    
                        {
                            filters.map((data) => (
                                <FormControlLabel value={data.text} 
                                    control={
                                    <Radio
                                    size="small" 
                                    sx={{
                                    color: "#1C485F",
                                    '&.Mui-checked': {
                                        color: "#1C485F",
                                    },
                                    }} 
                                    disableRipple
                                    />
                                    }
                                    label={data.text}
                                    />
                            ))
                        }
                </RadioGroup>
                </FormControl>
            </StyledMenu>
        </div>
    );
}